export const CHANGE_CREDENTIAL = 'CHANGE_CREDENTIAL';
export const CHANGE_COMMENT = 'CHANGE_COMMENT';

export const ADD_ORDER = 'ADD_ORDER';
export const UPDATE_ORDER = 'UPDATE_ORDER';
export const REMOVE_ORDER = 'REMOVE_ORDER';

export const UPDATE_ZIP = 'UPDATE_ZIP';


// WEBPACK FOOTER //
// ./src/app/actions/actions.js